import financeiro from './financeiro.routes';
import seguranca from './seguranca.routes';
import dados from './dadosPessoais.routes';

const MeuPerfil = () => import('@/views/MeuPerfil.vue');

const routes = [
  {
    path: '/meu-perfil',
    name: 'meu-perfil',
    component: MeuPerfil,
    meta: {
      title: 'Meu perfil',
    },
  },
  ...dados,
  ...financeiro,
  ...seguranca,
];

export default routes;
